import { render } from "./icon-eye-closed.vue?vue&type=template&id=cdf38efa"
const script = {}

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__